import { usePlanStockTarget as useStockTarget } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-target/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanStockTarget = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { stockTypeTerm, stockTypeTarget, maxDailyStockNum } = viewModel;

	return useStockTarget({ stockTypeTerm, stockTypeTarget, maxDailyStockNum, onSetViewModel });
};
